import React from 'react';
import PropTypes from 'prop-types';

const AwpYesNoDialog = ({ action, setShowYesNoConfirm, msg = 'Are you sure you want to delete?', props }) => {
  const onCancelDeleteClick = (event) => {
    event.preventDefault();
    setShowYesNoConfirm(false);
  };

  return (
    <div>
      <div>
        {msg}
        <div style={props.style} className="d-lg-inline mt-3 mt-lg-0 col-md-4">
          <button
            style={props.style}
            type="button"
            className="btn btn-outline-secondary ml-lg-3"
            onClick={onCancelDeleteClick}
          >
            No
          </button>
          <button
            style={props.style}
            type="button"
            className="btn btn-outline-secondary ml-3 js-delete-btn"
            onClick={action}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

AwpYesNoDialog.propTypes = {
  action: PropTypes.func,
  setShowYesNoConfirm: PropTypes.func,
};

export default AwpYesNoDialog;
